import PropTypes from 'prop-types';

export const inputPropTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    control: PropTypes.object.isRequired,
    inputRef: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.bool
    ]),
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    pattern: PropTypes.string,
    labelClass: PropTypes.string,
    inputClass: PropTypes.string,
    errorClass: PropTypes.string,
    rowClass: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    maxLength: PropTypes.string,
    errors: PropTypes.objectOf(
        PropTypes.shape({
            message: PropTypes.string,
            type: PropTypes.string,
        }),
    ),
    warning: PropTypes.string,
    info: PropTypes.string,
};

export const inputDefaultProps = {
    inputRef: () => {},
    value: '',
    onChange: () => {},
    onBlur: () => {},
    placeholder: null,
    pattern: null,
    labelClass: undefined,
    inputClass: 'form-element',
    errorClass: 'form-element--has-error',
    rowClass: undefined,
    readOnly: false,
    disabled: false,
    required: false,
    maxLength: null,
    fieldRef: null,
    errors: {},
    warning: null,
    info: null,
};
